import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonSlides, ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { AuthService } from '../../../service/auth/auth.service';
import { ConfigService } from '../../../service/config/config.service';

export interface notification {
  displayname:string,
  content:string,
  read:boolean,
  sendericon:string,
  displaydeadline:string,
  action:string,
  actionIdParameter:number,
  url:string,
  id:number,
  farmerId:number,
  createdAt:string,
  updatedAt:string,
  createdBy:number,
  updatedBy:number,
  deletedAt:string,
  deletedBy:number,
  factoryId:number
}

export interface rentalAgreement {
  dealtype: string,
  period: string,
  senderIsRenter: boolean,
  amount: number,
  beginDate: string,
  endDate: string,
  createdBy: string,
  createdAt: string,
  senderSignedDate: string,
  receiverSignedDate: string,
  factorySignedDate: string,
  description: string,
  status: string,
  statuscode: string,
  id: number,
  senderId: number,
  receiverId: number,
  factoryId: number
}

@Component({
  selector: 'app-rentalagreement-accept',
  templateUrl: './rentalagreement-accept.page.html',
  styleUrls: ['./rentalagreement-accept.page.scss'],
})
export class RentalagreementAcceptPage implements OnInit {

  @ViewChild('slides') slides: IonSlides;

  @Input() modalCtrl: ModalController;
  @Input() notification: any;

  public rentalagreementId: number;
  public rentalagreement: rentalAgreement;

  public formSubmitting: boolean = false;


  constructor(private config: ConfigService, private auth: AuthService, private http: HttpClient, private alertCtrl:AlertController) {
    this.rentalagreement = {dealtype:null, period:null, senderIsRenter: null, amount: null, beginDate:null, endDate:null, createdBy: null, createdAt:null, senderSignedDate: null, receiverSignedDate:null, factorySignedDate:null, status:null, statuscode:null, senderId:null, receiverId:null, factoryId:null, id:0, description:''};

  }


  closeModal() {
    return this.modalCtrl.dismiss(this.rentalagreementId);
  }

  ngOnInit() {
    var notificationData: notification = this.notification;
    this.rentalagreementId = notificationData.actionIdParameter;
    this.remoteGetAgreement()
  }

  handleError(error: any) {
    console.error(error);
    return Observable.throw(error.json().error || 'Server error');
  }

  updateAgreementStatus(change: string){

    this.formSubmitting = true;

    let headers: HttpHeaders = new HttpHeaders();
    headers = headers.append('Content-Type', 'application/json');
    headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

    const options = {
      headers: headers
    };


    let changeParam: object = {'status':'approvedByReceiver'};
    if(change==='reject'){
      changeParam = {'status':'rejectedByReceiver'};
    }


    return this.http.patch(this.config.basePath + '/api/rentalagreements/'+ this.rentalagreement.id, changeParam, options)
    .subscribe(
      (val) => {
        this.formSubmitting = false;
        if(change==='approve'){
          this.slides.slideNext();
        }else{
          this.closeModal();
        }
        
      },
      response => {
        this.handleError(response);
      }
    );
  }

  acceptAgreement(){
    this.updateAgreementStatus('approve');
  } 
  rejectAgreement(){
    this.updateAgreementStatus('reject');
  }

  async remoteGetAgreement():Promise<any>{
    if(this.auth.userProfile){

      let headers: HttpHeaders = new HttpHeaders();
      headers = headers.append('Content-Type', 'application/json');
      headers = headers.append('Authorization', localStorage.getItem('access_token') || '{}');

      const options = {
        headers: headers
      };


      return await this.http.get<rentalAgreement>(this.config.basePath + '/api/rentalagreements/' + this.rentalagreementId, options)
        .subscribe(
          (res)=>{
              this.rentalagreement = res;

              console.log('this.rentalagreement',res.status)

          if(res.status != 'approvedBySender'){
            this.openAlert();
            return;
          }

        })
    }
  }

  async openAlert(){
    let alert = await this.alertCtrl.create({
      header: 'Bemærk',
      message: 'Du har allerde godkendt aftalen og du kan derfor ikke godkende den igen.',
      buttons: [
        {
        text: 'OK',
        handler: () => {
          this.closeModal();
        },
        }
      ],


    });
    await alert.present();
  }

}
